import {Localizer} from "../../../infrastructure/localization/localizer";
import React, {useEffect} from "react";
import {Loading} from "../../../core/components/loading/loading";
import {KompetenceEvalueringOverview} from "./kompetenceEvalueringOverview";
import useKompetenceEvalueringsskemaHook from "./useKompetenceEvalueringsskemaHook";
import {LaegekompetenceMeta} from "../../../core/sharedmodels/kompetence/laegekompetenceMeta";
import {KompetenceEvalueringsskemaModel} from "../../../core/sharedmodels/evaluering/kompetenceEvalueringsskemaModel";

export interface KompetenceEvalueringsskemaerOverviewProps {
    laegeKompetence: LaegekompetenceMeta;
    deleteKompetenceEvalueringCallback: () => void;
    onEvalueringCountLoaded?: (count: number) => void;
}

export function KompetenceEvalueringsskemaerOverview({
                                                         laegeKompetence,
                                                         deleteKompetenceEvalueringCallback,
                                                         onEvalueringCountLoaded
                                                     }: KompetenceEvalueringsskemaerOverviewProps) {

    const { kompetenceEvalueringsskemaerState, isLoading, deleteKompetenceEvaluering } = useKompetenceEvalueringsskemaHook(laegeKompetence.kompetenceId, laegeKompetence.laegekompetenceId);

    const kompetenceEvalueringsskemaer = kompetenceEvalueringsskemaerState ?? [];
    const totalEvalueringCount = kompetenceEvalueringsskemaer
        .flatMap(kes => kes.kompetenceEvalueringer ?? [])
        .length;

    useEffect(() => {
        if (!isLoading && onEvalueringCountLoaded) {
            onEvalueringCountLoaded(totalEvalueringCount);
        }
    }, [isLoading, totalEvalueringCount, onEvalueringCountLoaded]);

    const sortBySenestGemtDato = (a: KompetenceEvalueringsskemaModel, b: KompetenceEvalueringsskemaModel): number => {
        const getMaxDate = (skema: KompetenceEvalueringsskemaModel): number =>
            Math.max(0,...skema.kompetenceEvalueringer.map(e => e.senestGemtDato.getTime()));
        return getMaxDate(b) - getMaxDate(a);
    };

    const aktiveSkemaer = kompetenceEvalueringsskemaer.filter(x => x.aktiv).sort(sortBySenestGemtDato);
    const inaktiveSkemaer = kompetenceEvalueringsskemaer.filter(x => !x.aktiv).sort(sortBySenestGemtDato);

    return (
        <Loading isLoading={isLoading} text={Localizer.KompetenceVurderingLoading()} spinnerClasses={"margin-m"}>
            {[
                { title: Localizer.global_active(), skemaer: aktiveSkemaer, showHeading: true },
                { title: Localizer.global_inactive(), skemaer: inaktiveSkemaer, showHeading: true }
            ]
                .filter(section => section.skemaer.length > 0)
                .map(section => (
                <div key={section.title} className={"kompetenceEvalueringsskemaerOverview__section"}>
                    {section.showHeading && <h3 className={"margin-bottom-s margin-left-m margin-right-m"}>{section.title}</h3>}
                    {section.skemaer.map(x =>
                        <KompetenceEvalueringOverview key={x.kompetenceEvalueringsskemaId} kompetenceEvalueringsskema={x}
                                                      brugerMaalbeskrivelseId={laegeKompetence.brugerMaalbeskrivelseId}
                                                      deleteKompetenceEvaluering={(deletedRelationId: string) => {
                                                          deleteKompetenceEvaluering(deletedRelationId).then(() => deleteKompetenceEvalueringCallback());
                                                      }}/>
                    )}
                </div>
            ))}
        </Loading>
    );
}
